<template>
  <div class="wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <NotFoundText v-if="!this.data" />
    <div v-else class="content">
      <CustomTable
        title="Материалы"
        :rowsData="this.data?.materials || []"
        :columns="this.materialRequestsColumnsSmall"
        :loading="isFetching"
        :hideTopTitle="true"
        :custom-body="true"
        :bottomRow="true"
        :sticky-header="false"
      >
        <template #customBody="props">
          <q-tr>
            <custom-table-cell align="left" vertical-align="center">
              {{ props.row.material_name }}
            </custom-table-cell>
            <custom-table-cell align="right" vertical-align="center">
              {{ `${props.row.material_amount} ${props.row.sell_unit_name}` }}
            </custom-table-cell>
            <custom-table-cell align="right" vertical-align="center">
              <Amount :value="props.row.material_sum" />
            </custom-table-cell>
          </q-tr>
        </template>

        <template v-if="this.data?.materials?.length" #bottomRow="props">
          <q-tr class="bg-grey-3 text-bold">
            <q-td colspan="2">Итого</q-td>
            <q-td align="right"> <Amount :value="this.amountSum" /></q-td>
          </q-tr>
        </template>
      </CustomTable>
      <q-separator />

      <q-list class="workSetMaterials">
        <h2 class="materials__title">Материалы по конструктивам</h2>
        <q-expansion-item
          v-for="type in this.data?.materials_ws"
          :key="type.placement_type_id"
          :class="['custom-expansion', 'custom-expansion__parent']"
          expand-icon="keyboard_arrow_down"
          expand-icon-class="custom-expand-icon"
          header-class="custom-expansion__header"
          header-style="min-height: 40px"
          :label="type.placement_type_name"
          style="border: 1px solid #ccc;"
        >
          <q-list class="child">
            <q-expansion-item
              v-for="group in type.work_set_check_groups"
              :key="group.work_set_check_group_id"
              :label="group.work_set_check_group_name"
              class="custom-expansion"
              expand-icon="keyboard_arrow_down"
              header-style="min-height: 40px; background-color: rgb(229, 229, 229);"
              expand-icon-class="custom-expand-icon"
            >
              <q-list
                style="padding: 15px 10px 15px 15px; border: 1px solid #ccc; border-top: none; border-right: none"
              >
                <CustomTable
                  title=""
                  :rowsData="group?.work_sets || []"
                  :columns="this.workSetColumns"
                  :loading="isFetching"
                  :hideTopTitle="true"
                  :custom-body="true"
                  :bottomRow="true"
                  :sticky-header="false"
                >
                  <template #customBody="props">
                    <q-tr>
                      <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.work_set_name }}
                      </custom-table-cell>
                      <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.material_name }}
                      </custom-table-cell>
                      <custom-table-cell align="right" vertical-align="center">
                        {{ `${props.row.material_amount} ${props.row.unit_name}` }}
                      </custom-table-cell>
                      <custom-table-cell align="right" vertical-align="center">
                        <Amount :value="props.row.material_sum" />
                      </custom-table-cell>
                    </q-tr>
                  </template>

                  <template v-if="group?.work_sets?.length" #bottomRow="props">
                    <q-tr class="bg-grey-3 text-bold">
                      <q-td colspan="3">Итого</q-td>
                      <q-td align="right">
                        <Amount
                          :value="this.getWorkSetsAmountSum(group?.work_sets)"
                      /></q-td>
                    </q-tr>
                  </template>
                </CustomTable>
              </q-list>
            </q-expansion-item>
          </q-list>
        </q-expansion-item>
      </q-list>
    </div>
  </div>
</template>

<script>
import Amount from "@/components/common/Amount.vue";
import BlockItem from "@/components/common/BlockItem";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { getFloorMaterials, materialRequestsColumnsSmall, workSetColumns } from './services';

export default {
  name: "FloorDetailMaterials",
  components: {BlockItem, CustomTable,CustomTableCell, Amount},
  props: ['floorMapId'],
  data() {
    return {
      workSetColumns,
      materialRequestsColumnsSmall,
      isFetching: false,
      data: null,
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getFloorMaterials(this.floorMapId)
      this.isFetching = false
      if(!res) return
      this.data = res
    },
    formatPrice(value) {
      return new Intl.NumberFormat("ru-RU", {
        maximumFractionDigits: 0
      }).format(value)
    },
    getWorkSetsAmountSum(work_sets) {
      return work_sets.reduce((acc, item) => {
        return acc + (item.material_sum || 0)
      }, 0)
    }
  },
  computed: {
    amountSum() {
      return this.data?.materials.reduce((acc, item) => {
        return acc + (item.material_sum || 0)
      }, 0)
    },
  },
  mounted() {
    this.getData()
  }
};
</script>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px
}
.wrapper {
  padding: 20px;
  padding-top: 0;
}
.materials__title {
  font-size: 25px;
  margin: 0;
  line-height: 37px;
  margin-bottom: 15px;
}
.custom-expansion {
  font-size: 12px;
  padding: 0;
  font-weight: 400;
  min-height: 40px !important;
  margin-top: 5px;
  &__header {
    padding: 5px 15px;
  }
}
.custom-expansion__header {
  padding: 5px 15px;
}
.custom-expansion__parent {
  font-size: 13px;
  font-weight: 600;
}
.custom-expand-icon {
  font-size: 14px;
}
.child {
  padding-left: 16px;
  padding-bottom: 15px;
}
.workSetMaterials {
  width: 700px;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
